export { default as translations } from './translations.json';

export const ALL_BADGES = ['superhost', 'quick_responder', 'expert_seller', 'rising_star'];

/**
 * Get host badges from user.
 * @param {Object|null} user
 * @returns {string[]}
 */
export const getHostBadges = (user) =>
  user?.attributes?.metadata?.hostBadges || [];

export const hasBadge = (user, badge) => getHostBadges(user).includes(badge);
export const isSuperhost = (user) => hasBadge(user, 'superhost');
